import * as React from "react";
import { notification, Spin } from "antd";
import { useState, useContext, useEffect } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import DataGrid, { Column, Pager, Paging, FilterRow, HeaderFilter, GroupPanel, Grouping, Selection, Export } from "devextreme-react/data-grid";
import { MoneyMask } from "src/util/Masks/MoneyMask";
import { PercentageMask } from "src/util/Masks/PercentageMask";
import { ServiceContext } from "src/services/provider/Service.provider";
import { AuthContext } from "src/components/context/AuthContext";
import { IQuote } from "src/services/interfaces/trade/precificacao/IQuote";

function QuotesTable(props: { style?: React.CSSProperties; pageSize?: number; max?: number; } & RouteComponentProps<any>) {
  const { currentUser } = useContext(AuthContext);
  const { quoteService } = useContext(ServiceContext);

  const [loading, setLoading] = useState(false);
  const [quotes, setQuotes] = useState<IQuote[]>([]);

  useEffect(() => {
    fetch();
  }, []);

  async function fetch(params = {}) {
    try {
      setLoading(true);
      let quotesResponse = await quoteService.getAll();
      if (props.max) {
        quotesResponse = quotesResponse.slice(0, props.max);
      }
      setQuotes(quotesResponse);
    } catch (error) {
      notification.error({ message: "Falha na consulta", description: "Ocorreu um erro durante a consulta. Tente novamente." });
    } finally {
      setLoading(false);
    }
  }

  const moneyMask = (params: any) => MoneyMask(params.value!);

  return (
    <Spin spinning={loading}>
      <DataGrid
        dataSource={quotes}
        allowColumnReordering={true}
        showBorders={true}
        loadPanel={{ enabled: loading }}
        rowAlternationEnabled={true}
        hoverStateEnabled={true}
        columnAutoWidth={true}
      >
        <GroupPanel visible={true} />
        <Grouping autoExpandAll={true} />
        <Selection mode={"multiple"} selectAllMode={true} showCheckBoxesMode={true} />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />

        <Column caption="Id Cotação" dataField="id" dataType="number" alignment={"center"} />
        <Column caption="Status" alignment={"center"} dataField="status" dataType="string" />
        <Column caption="Usuário" alignment={"center"} dataField="user.fullName" dataType="string" />
        <Column caption="Requerente" dataField="precatorio.requester" dataType="string" alignment={"center"} />
        <Column caption="CPF/CNPJ" dataField="precatorio.cpfCnpj" dataType="string" alignment={"center"} />
        <Column caption="Processo" dataField="precatorio.processCode" dataType="string" alignment={"center"} />
        <Column caption="Tribunal" dataField="precatorio.court.name" dataType="string" alignment={"center"} />
        <Column caption="Tipo" dataField="precatorio.type.name" dataType="string" alignment={"center"} />
        <Column caption="Correção" dataField="precatorio.correctionType.name" dataType="string" alignment={"center"} />
        <Column caption="Percentual do Credor" alignment={"center"} dataField="pricing.reducedPercentLender" dataType="number"
          cellRender={params => PercentageMask(params.data.pricing.reducedPercentLender === null ? 1 : params.data.pricing.reducedPercentLender, 2, 2)}
        />
        <Column caption="Valor atual" alignment={"center"} dataField="precatorio.principal" dataType="number" format="currency" cellRender={moneyMask} />
        <Column caption="Valor Venda" alignment={"center"} dataField="pricing.price" dataType="number" cellRender={moneyMask} />

        <Column caption="Comissão" alignment={"center"} dataField="pricing.commission.officer.full.value" dataType="number" format="currency" visible={currentUser.permissions.userCanSeeCommission}
          cellRender={params => MoneyMask(params.data.pricing.commission.officer.full.value)} />
        <Column caption="% Comissão" alignment={"center"} dataField="pricing.commission.officer.full.percentage" dataType="number" visible={currentUser.permissions.serCanSeeCommission}
          cellRender={params => PercentageMask(params.data.pricing.commission.officer.full.percentage, 2, 2)}
        />
        <Column caption="PSS" alignment={"center"} dataField="precatorio.isPss" dataType="boolean" />
        <Pager allowedPageSizes={[10, 25, 50, 100]} showPageSizeSelector={true} />
        <Paging defaultPageSize={20} />
        <Export enabled fileName="Cotações" allowExportSelectedData={false} />
      </DataGrid>
    </Spin>
  );
}

export default withRouter(QuotesTable);



// WEBPACK FOOTER //
// ./src/pages/gerencial/quotes/QuotesTable.tsx